import React from 'react'

interface Props {
  className?: string
}

export const SprintSpecIcon: React.FC<Props> = ({ className = 'h-6 w-6' }) => {
  return (
    <svg
      viewBox="0 0 254.74 226.32"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M39.81,-5.03"
        className="stroke-current"
        fill="none"
        strokeWidth="52"
        strokeMiterlimit="10"
      />
      <path
        d="M51.25,26.05a80.92,80.92,0,0,1,10.47.61"
        className="stroke-current"
        fill="none"
        strokeWidth="52"
        strokeMiterlimit="10"
      />
      <path
        d="M82.51,30.37c26.54,6.4,64.51,21.76,95.79,57.43,37.49,42.74,47.13,89.89,49.6,117.46"
        className="stroke-current"
        fill="none"
        strokeWidth="52"
        strokeMiterlimit="10"
        strokeDasharray="21.14 21.14"
      />
      <path
        d="M228.58,215.8c.18,4.67.17,8.25.16,10.5"
        className="stroke-current"
        fill="none"
        strokeWidth="52"
        strokeMiterlimit="10"
      />
      <path
        d="M51.25,226.67"
        className="stroke-current"
        fill="none"
        strokeWidth="52"
        strokeMiterlimit="10"
      />
      <line
        x1="26"
        y1="226.3"
        x2="26"
        y2="0"
        className="stroke-current"
        fill="none"
        strokeWidth="52"
        strokeMiterlimit="10"
      />
    </svg>
  )
}
